import React from 'react';

const PasteIcon = () => {
  return (
    <svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#zngxo3q75a)">
        <path
          d="M11.25 6.25c.453 0 .832.32.918.75.059.29.316.5.613.5h.344c.344 0 .625.281.625.625v.625h-5v-.625c0-.344.281-.625.625-.625h.344c.297 0 .554-.21.613-.5a.935.935 0 0 1 .918-.75zM7.5 7.5h.105a1.943 1.943 0 0 0-.105.625v.625c0 .691.559 1.25 1.25 1.25h5c.691 0 1.25-.559 1.25-1.25v-.625c0-.219-.04-.43-.105-.625H15c.691 0 1.25.559 1.25 1.25h1.25c0-1.379-1.121-2.5-2.5-2.5h-1.773A2.19 2.19 0 0 0 11.25 5a2.19 2.19 0 0 0-1.977 1.25H7.5A2.502 2.502 0 0 0 5 8.75V20c0 1.379 1.121 2.5 2.5 2.5h5v-1.25h-5c-.691 0-1.25-.559-1.25-1.25V8.75c0-.691.559-1.25 1.25-1.25zm8.75 16.25c-.691 0-1.25-.559-1.25-1.25v-10c0-.691.559-1.25 1.25-1.25H20v2.188C20 14.3 20.7 15 21.563 15h2.187v7.5c0 .691-.559 1.25-1.25 1.25h-6.25zm5-12.293 2.293 2.293h-1.98a.313.313 0 0 1-.313-.313v-1.98zM22.5 25c1.379 0 2.5-1.121 2.5-2.5v-8.285c0-.496-.2-.973-.55-1.324l-2.34-2.34A1.875 1.875 0 0 0 20.784 10H16.25a2.502 2.502 0 0 0-2.5 2.5v10c0 1.379 1.121 2.5 2.5 2.5h6.25z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="zngxo3q75a">
          <path fill="#fff" transform="translate(5 5)" d="M0 0h20v20H0z" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default PasteIcon;
